module.exports = __webpack_public_path__ + "img/solution-25d2.ecdfd6cc.png";